import React from 'react';

const BaseInput = ({
  label,
  name,
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  touched,
  disabled,
  rows,
  required = true,
}) => {
  const InputComponent = type === "textarea" ? "textarea" : "input";

  return (
    <div className="mb-3">
      {label && (
        <label htmlFor={name} className="form-label">
          {label}
          {required && <span className="text-danger"> *</span>} {/* Show red star if required is true */}
        </label>
      )}
      <InputComponent
        type={type}
        className={`form-control ${error && touched ? "is-invalid" : ""}`}
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        rows={rows}
      />
      {error && touched && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default BaseInput;
